import { render, staticRenderFns } from "./WaterQualityMonitoring.vue?vue&type=template&id=179d1969&scoped=true"
import script from "./WaterQualityMonitoring.vue?vue&type=script&lang=js"
export * from "./WaterQualityMonitoring.vue?vue&type=script&lang=js"
import style0 from "./WaterQualityMonitoring.vue?vue&type=style&index=0&id=179d1969&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d1969",
  null
  
)

export default component.exports